import React, { RefObject } from 'react'
import { Switch as MuiSwitch, SwitchProps } from '@mui/material'

interface PropsType extends SwitchProps {
	inputRef?: RefObject<any>
}

export const Switch = (props: PropsType) => {
	return <MuiSwitch inputRef={props.inputRef} {...props} />
}
